import axios from "axios"
export const api_key = 'https://apivitality.japa.health/api/v1/'
// export const api_key = 'https://devapi.japa.health/api/v1/'
// export const api_key = 'https://rsz1fsxz-7000.inc1.devtunnels.ms/api/v1/'  //DEVLOPEMENET SERVER

/** Shown in first-login modal if GET /me/first-login-offer returns no code. Override with REACT_APP_FIRST_LOGIN_PROMO_CODE in .env */
export const firstLoginPromoFallback = String(
  process.env.REACT_APP_FIRST_LOGIN_PROMO_CODE != null &&
    process.env.REACT_APP_FIRST_LOGIN_PROMO_CODE !== ""
    ? process.env.REACT_APP_FIRST_LOGIN_PROMO_CODE
    : "SHERYL"
).trim();

/** Program subscription ID for first-login modal → POST create-pay-checkout (same as Memberships). Set REACT_APP_STANDARD_6MO_CHECKOUT_PROGRAM_ID or defaults to 10. */
const rawCheckoutSubscriptionId = process.env.REACT_APP_STANDARD_6MO_CHECKOUT_PROGRAM_ID;
export const standardSixMonthCheckoutProgramId = (() => {
  if (rawCheckoutSubscriptionId != null && String(rawCheckoutSubscriptionId).trim() !== "") {
    const n = Number(rawCheckoutSubscriptionId);
    return Number.isFinite(n) ? n : 6;
  }
  return 6;
})();

const api = axios.create({
    baseURL: api_key,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('userKey');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
            config.headers['authorization-user'] = `Bearer ${localStorage.getItem('fingerprint')}`;
        }
        return config
    },
    (error) => {
        return Promise.reject(error);
    }
)
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response) {
            // Handle 401 (Unauthorized) - Redirect to login
            if (error.response.status === 401) {
                console.error('Unauthorized, redirecting to login...');
                localStorage.clear();
                window.location.href = '/signin';
                window.location.reload();
            }
            // Handle other status codes globally
            return Promise.reject(error.response.data);
        }
        return Promise.reject(error);
    }
)

export default api;